import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { Avatar, Button, Checkbox, Grid2, Grid,MenuItem, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip, CircularProgress, TextField } from "@mui/material";
import TokenError from "../tokenError";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import 'react-quill/dist/quill.snow.css';
import { Label } from "flowbite-react";
import axios from "axios";
import UploadIcon from '../../assets/icons/Upload.svg';
import InfoIcon from '../../assets/icons/Info.svg';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';

// Lazy load the ReactQuill editor for better performance
import { lazy, Suspense } from 'react';
const ReactQuill = lazy(() => import('react-quill'));

const Pushes= () => {

    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [driverCustomer, setDriverCustomer] = useState(0);
    const [pushTitle, setPushTitle] = useState('');
    const [vehicleType, setVehicleType] = useState(0);
    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [errorMessage, setErrorMessage] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customMessage, setCustomMessage] = useState('');
    const [selectedUser, setSelectedUser] = useState([]);
    const [selectedUserIds, setSelectedUserIds] = useState([]);
    const [vehicleClient, setVehicleClient] = useState([]);
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [image, setImage] = useState('');
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const fileInputRef = useRef(null);
    const [isSending, setIsSending] = useState(false);
    const removeDriverPushes = localStorage.getItem('remove_driver_pushes') || 0;
    const pushesInHtml = localStorage.getItem('pushes_in_html');
    const [paginationInfo, setPaginationInfo] = useState({ total: 0, page_count: 1 });
    const [totalPages, setTotalPages] = useState(1);
    const [filteredRows, setFilteredRows] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const country_code = localStorage.getItem('default_country_iso_code' || 'IN');
    const searchTimeoutRef = useRef(null);
    const [sendtoall, setSendtoall] = useState(0);

    
    console.log(selectedUser,"selectedUser")

    const handlePhoneChange = (value) => {
        const previousPhone = customerPhone;
        const newValue = value || ''; // Handle undefined when input is cleared
        setCustomerPhone(newValue);
      
        // Parse phone number to get country code (optional, for logging or other use)
        let countryCode = '';
        try {
          const parsed = parsePhoneNumber(newValue);
          if (parsed) {
            countryCode = parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '';
          }
        } catch (err) {
          console.error('Invalid phone number:', err);
        }
      
        // Clear any existing timeout
        if (searchTimeoutRef.current) {
          clearTimeout(searchTimeoutRef.current);
        }
      
        // If input is being cleared and we had a previous value
        if (newValue.length === 0 && previousPhone.length > 0) {
          fetchUSersData(1, rowsPerPage, '', ''); // Reset search
          return;
        }
      
        // Only make API call if the input has 6 or more characters (including country code)
        if (newValue.length >= 6) {
          searchTimeoutRef.current = setTimeout(() => {
            fetchUSersData(1, rowsPerPage, '', newValue); // Pass the phone number to search
          }, 500);
        }
    };

    const navigate = useNavigate();

    const driver_vehicle_attachment_enabled = localStorage.getItem('driver_vehicle_attachment_enabled');
    const is_client_owned_vehicle =  localStorage.getItem('is_client_owned_vehicle');

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    console.log(paginatedData,"paginatedData")

        useEffect(() => {
            let filtered = rows;
        
            setFilteredRows(filtered);
            setPaginatedData(filtered);
            if (filtered.length !== filteredRows.length) {
                setPage(0);
                fetchUSersData(1, rowsPerPage, '', '');
            }
            // setPage(0);
        }, [rows,filteredRows.length]);

    const sendPush = async() => {
        if (isSending) return; // Prevent multiple clicks
        
        // Validation
        if (!customMessage.trim() || customMessage.trim() === '<p><br></p>') {
            return;
        }
        
        if (selectedUserIds.length === 0) {
            return;
        }
        
        if (!pushTitle.trim()) {
            return;
        }

        setIsSending(true);
        
        try {
            const token = localStorage.getItem('token');
            
            // Format the user array with required fields
            const userArray = selectedUser.map(user => ({
                id: user.user_id || user.driver_id,
                name: user.user_name || user.driver_name || '',
                phone_number: user.phone_number || '',
                device_type: user.device_type,
                device_token: user.device_token || '',
            }));
            
            const payload = {
                token: token,
                message: customMessage,
                user_array: userArray,
                user_type: driverCustomer,
                title: pushTitle,
                send_to_all: sendtoall,
                city_id: cityFilter,
            };
            
            if (image !== '') {
                payload.banner = image;
            }
            
            const response = await makePostRequestToUrl(operationsUrl + '/panel/send_pushes', payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                setSelectedUser([]);
                setSelectedUserIds([]);
                setCustomMessage('');
                setPushTitle('');
                setImage('');
                setFileInputKey(Date.now());
                setSendtoall(0);
            }
        } catch (error) {
            console.error('Error sending push:', error);
        } finally {
            setIsSending(false);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        fetchUSersData(newPage + 1, rowsPerPage, '', '');
        navigate(`?page=${newPage + 1}`); // Update URL
    };

    // const fetchUSersData = async(page = 1, limit = 50, userId = '', phoneNumber = '') => {
    //     try {
    //         const token = localStorage.getItem('token');
    //         const url = serverUrl + (driverCustomer == 1 ? '/driver/fetch_all' : '/customer/fetch_all');
    //         const timestamp = new Date().getTime();
    //         const body = {
    //             token: token,
    //             timestamp: timestamp,
    //             page: page,
    //             page_size: limit,
    //             city_id: cityFilter,
    //         };
            
    //         // Add phone number to the request if provided
    //         if (phoneNumber) {
    //             body.phone_number = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
    //         }
            
    //         if(driverCustomer == 1 && vehicleType != 0) {
    //             body.vehicle_type = vehicleType;
    //         }
            
    //         const response = await makeGetRequestToUrl(url, body);
            
    //         if(response.flag == 200) {
    //             const data = response.data || [];
    //             const totalItems = response.pagination?.total || 0;
    //             const totalPages = Math.ceil(totalItems / limit);
                
    //             setPaginationInfo({
    //                 total: totalItems,
    //                 page_count: totalPages,
    //             });
    //             setTotalPages(totalPages);
                
    //             // Apply default sorting (descending by user_id)
    //             const sortedData = [...data].sort((a, b) => {
    //                 const idA = a.user_id || a.driver_id || 0;
    //                 const idB = b.user_id || b.driver_id || 0;
    //                 return idB - idA;
    //             });
                
    //             setRows(sortedData);
    //             setFilteredRows(sortedData);
    //             setPaginatedData(sortedData);
    //         }
    //         if(response.flag==102){
    //             console.log('Token is expired. Please login again')
    //             localStorage.removeItem('token');
    //             setErrorMessage('Your session has expired. Please log in again.');
    //             setTokenExpired(true);

    //             setTimeout(() => {
    //                 navigate('/signup');
    //             }, 2000);
    //             // navigate('/signup');
    //         }
    //     } catch (error) {
    //         console.error('Error fetching users:', error);
    //     }
    // }

    const fetchUSersData = async(page = 1, limit = 50, userId = '', phoneNumber = '') => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + (driverCustomer == 1 ? '/driver/fetch_all' : '/panel/fetch_customers_to_send_push');
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp,
                page: page,
                page_size: limit,
                city_id: cityFilter,
            };
            
            // Add phone number to the request if provided
            if (phoneNumber) {
                body.phone_number = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
            }
            
            if(driverCustomer == 1 && vehicleType != 0) {
                body.vehicle_type = vehicleType;
            }
            
            const response = await makeGetRequestToUrl(url, body);
            
            if(response.flag == 200) {
                const data = response.data || [];
                const totalItems = response.pagination?.total || 0;
                const totalPages = Math.ceil(totalItems / limit);
                
                setPaginationInfo({
                    total: totalItems,
                    page_count: totalPages,
                });
                setTotalPages(totalPages);
                
                // Apply default sorting (descending by user_id)
                const sortedData = [...data].sort((a, b) => {
                    const idA = a.user_id || a.driver_id || 0;
                    const idB = b.user_id || b.driver_id || 0;
                    return idB - idA;
                });
                
                setRows(sortedData);
                setFilteredRows(sortedData);
                setPaginatedData(sortedData);
            }
            // ... rest of the error handling
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchVehicleClient = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/vehicle/get_client_vehicles';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Filter active vehicles
                const activeVehicles = response.data.filter(vehicle => vehicle.is_active === 1);
                setVehicleClient(activeVehicles);
                setVehicleType(0);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        setSelectedUser([]);
        setSelectedUserIds([]);
        setCustomMessage('');
        setRows([]);

        if (driverCustomer == 1) {
            fetchVehicleClient();
            fetchUSersData();
        } 
        if (driverCustomer == 0) {
            fetchUSersData();
        }
    }, [driverCustomer]);

    useEffect(() => {
        if ( (driverCustomer == 1 && vehicleType !== '')) {
            fetchUSersData();
        }
    }, [ vehicleType]);

    useEffect(() => {
        fetchUSersData();
    }, [cityFilter]);

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
    };

    const handleFileChange = async (event) => {
        const fileInput = event.target;
        const files = fileInput.files;
    
        if (files.length === 0) {
            console.error("No file selected");
            return;
        }

        // Check file size (2MB max)
        const maxSize = 2 * 1024 * 1024; // 2MB in bytes
        if (files[0].size > maxSize) {
            setMessage("Image size should be less than 2MB");
            showSnackbar(true);
            fileInput.value = ''; // Clear the file input
            setFileInputKey(Date.now()); // Force re-render of file input
            return;
        }

        // Check file type
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (!allowedTypes.includes(files[0].type)) {
            setMessage("Only JPG, JPEG, and PNG files are allowed");
            showSnackbar(true);
            fileInput.value = ''; // Clear the file input
            setFileInputKey(Date.now()); // Force re-render of file input
            return;
        }

        // Check image dimensions
        const checkDimensions = (file) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = function() {
                    const width = this.width;
                    const height = this.height;
                    resolve({ width, height });
                };
                img.src = URL.createObjectURL(file);
            });
        };

        try {
            const { width, height } = await checkDimensions(files[0]);
            
            // Define maximum dimensions (adjust these values as needed)
            const MAX_WIDTH = 510;
            const MAX_HEIGHT = 350;
            const MIN_WIDTH = 300;
            const MIN_HEIGHT = 250;

            // Check dimensions
            if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                setMessage(`Image dimensions (${width}x${height}) are too large. Maximum allowed is ${MAX_WIDTH}x${MAX_HEIGHT}px`);
                showSnackbar(true);
                fileInput.value = ''; // Clear the file input
                setFileInputKey(Date.now()); // Force re-render of file input
                return;
            }

            if (width < MIN_WIDTH || height < MIN_HEIGHT) {
                setMessage(`Image dimensions (${width}x${height}) are too small. Minimum required is ${MIN_WIDTH}x${MIN_HEIGHT}px`);
                showSnackbar(true);
                fileInput.value = ''; // Clear the file input
                setFileInputKey(Date.now()); // Force re-render of file input
                return;
            }

            // If all validations pass, proceed with upload
            const formData = new FormData();
            formData.append("image", files[0]);
        
            const url = operationsUrl + '/upload_image';
        
            const response = await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        
            const s3Url = response.data.url;
            setImage(s3Url);
        } catch (error) {
            console.error("Error processing image:", error);
            setMessage("Error processing the image. Please try again with a different file.");
            showSnackbar(true);
            fileInput.value = ''; // Clear the file input
            setFileInputKey(Date.now()); // Force re-render of file input
        }
    };

      
    const moveToPushHistory = () => {
        navigate('/push-history');
    }

    // Quill editor to type without lag
    // Debounce function to delay state updates
    const debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    // Memoized debounced handler to prevent recreation on every render
    const handleEditorChange = useCallback(
        debounce((content) => {
            setCustomMessage(content);
        }, 300),
        []
    );

    // Minimal editor modules with only essential formatting
    const editorModules = useMemo(() => ({
        toolbar: [
            ['bold', 'italic', 'underline', 'strike',]
        ],
        clipboard: {
            matchVisual: false,
        }
    }), []);

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Pushes
            </Typography>

            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '2%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 sx={{marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        onClick={moveToPushHistory}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#0065ff',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        View Push Details
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 container item spacing={2} sx={{display:'flex', marginTop:'2%'}}>
                <Grid2 item size={4} className="mainBox" style={{maxHeight:'600px', overflow:'auto'}}>
                    <Typography sx={{color: '#4E545D', fontSize:'24px'}}>Create Push</Typography>

                    <Grid2 sx={{marginTop:'6%'}}>
                        <Typography sx={{color: '#2A313C'}}>Send Push to</Typography>

                        <Select
                            value={driverCustomer}
                            onChange={(e) => setDriverCustomer( e.target.value)} displayEmpty fullWidth
                            style={{ height: '50px', borderRadius: '8px', backgroundColor: driverCustomer ? '#F9F9F9' : '#FFFFFF', border: 'none', marginTop:'1%'}}>
                            {/* <MenuItem value="-1">Select</MenuItem> */}
                            {removeDriverPushes==0 && <MenuItem value="1">Driver</MenuItem>}
                            <MenuItem value="0">Customer</MenuItem>
                        </Select>
                    </Grid2>

                    <Grid2 xs="auto" sx={{marginTop:'4%'}}>
                    <Typography sx={{color: '#2A313C'}}>Notification Title <span style={{ color: 'red' }}>*</span></Typography>

                        <input type="text" placeholder="Notification Title" className='filterBtn' value={pushTitle} onChange={(e) => setPushTitle(e.target.value)}
                        style={{ height: '50px', borderRadius: '8px', backgroundColor: driverCustomer ? '#F9F9F9' : '#FFFFFF',border: '1px solid #E0E0E0', marginTop:'1%',width:'95%'}}
                        />
                    </Grid2>

                    <Grid item xs={12} sm={6} sx={{marginTop:'4%'}}>
                        <Label>Image (Optional)</Label>
                        <input
                            key={fileInputKey}
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            id="image-upload"
                        />
                        <label htmlFor="image-upload">
                            <div style={{
                                border: '1px dashed #B0BEC5',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                marginTop: '8px',
                                backgroundColor: '#F9F9F9',
                                '&:hover': {
                                    backgroundColor: '#F0F0F0',
                                }
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                    <img 
                                        src={UploadIcon} 
                                        alt="Upload" 
                                        style={{ width: '24px', height: '24px' }}
                                    />
                                    <Typography variant="caption" color="textSecondary">
                                        Choose File
                                    </Typography>
                                </div>
                            </div>
                        </label>
                        <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginTop: '8px' }}>
                            <img src={InfoIcon} alt="info" style={{ width: '15px', height: '15px', cursor: 'pointer' }} />
                            <Typography sx={{fontSize:'10px'}} color="textSecondary">
                                Size (max 2MB) & Dimension Should be max 510 x 350 Px & min 300 x 250 Px
                            </Typography>
                        </div>

                        {image && (
                            <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <img 
                                    src={image} 
                                    alt="Preview" 
                                    style={{ 
                                        height: '50px', 
                                        width: '50px',
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                    }}
                                />
                                <Button 
                                    variant="outlined" 
                                    size="small"
                                    onClick={() => {
                                        setImage('');
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = '';
                                            setFileInputKey(Date.now());
                                        }
                                    }}
                                >
                                    Remove
                                </Button>
                            </div>
                        )}
                    </Grid>

                    {false && (driverCustomer==1 && (driver_vehicle_attachment_enabled==1 || (driver_vehicle_attachment_enabled==0 && is_client_owned_vehicle==0))) && (
                        <Grid2 sx={{marginTop:'4%'}}>
                            <Typography sx={{color: '#2A313C'}}>Vehicle Type</Typography>

                            <Select
                                value={vehicleType}
                                onChange={(e) => setVehicleType( e.target.value)} displayEmpty fullWidth
                                style={{ height: '50px', borderRadius: '8px', backgroundColor: driverCustomer ? '#F9F9F9' : '#FFFFFF', marginTop:'1%'}}>
                                    <MenuItem value="0">All</MenuItem>
                                    {vehicleClient.map((vehicle) => (
                                        <MenuItem key={vehicle.vehicle_type} value={vehicle.vehicle_type}>
                                            {vehicle.vehicle_name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </Grid2>
                    )}

                    <Grid2 sx={{marginTop:'4%'}}>
                        <Typography sx={{color: '#2A313C'}}>Notification Message <span style={{ color: 'red' }}>*</span></Typography>

                        {pushesInHtml==1 ? <Suspense fallback={<div style={{height: '140px', border: '1px solid #E0E0E0', borderRadius: '8px'}}>Loading editor...</div>}>
                            <div className="quill-editor-container" style={{ marginTop: '1%', borderRadius: '8px', overflow: 'hidden' }}>
                                <ReactQuill
                                    theme="snow"
                                    value={customMessage}
                                    onChange={handleEditorChange}
                                    placeholder="Write your message here."
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                    }}
                                    className="custom-quill"
                                    modules={editorModules}
                                />
                                <style jsx global>{`
                                .custom-quill .ql-container {
                                    border: 1px solid #E0E0E0 !important;
                                    border-radius: 0 0 8px 8px !important;
                                    min-height: 140px;
                                }
                                .custom-quill .ql-toolbar {
                                    border: 1px solid #E0E0E0 !important;
                                    border-bottom: none !important;
                                    border-radius: 8px 8px 0 0 !important;
                                    background-color: #f8f9fa;
                                }
                                .custom-quill .ql-editor {
                                    min-height: 140px;
                                }
                            `}</style> 
                            </div>
                            <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginTop: '8px' }}>
                                <img src={InfoIcon} alt="info" style={{ width: '15px', height: '15px', cursor: 'pointer' }} />
                                <Typography sx={{fontSize:'10px'}} color="textSecondary">
                                    Placeholder For {driverCustomer == 1 ? 'Driver Name {name}': 'User Name {name}'}
                                    <br />
                                    Placeholder For {driverCustomer == 1 ? 'Driver Phone Number {phone_number}': 'User Phone Number {phone_number}'}
                                </Typography>
                            </div>
                        </Suspense>:<TextField
                            multiline
                            rows={4}
                            value={customMessage}
                            onChange={(e) => setCustomMessage(e.target.value)}
                            style={{
                                width: '100%',
                                height: '125px',
                                borderRadius: '8px',
                                border: '1px solidrgb(255, 254, 254)',
                                marginTop: '1%',
                                backgroundColor: '#F9F9F9',
                            }}
                        />}
                    </Grid2>
                    
                    <Grid2 style={{marginTop:'8%'}}>
                        <Button 
                            type="submit" 
                            variant="contained" 
                            disabled={!customMessage.trim() || 
                                     customMessage.trim() === '<p><br></p>' || 
                                     selectedUserIds.length === 0 || 
                                     !pushTitle.trim() ||
                                     isSending} 
                            fullWidth 
                            style={{ 
                                color:"#fff", 
                                textTransform:'none', 
                                borderRadius:'10px', 
                                backgroundColor: (customMessage.trim() && 
                                               customMessage.trim() !== '<p><br></p>' && 
                                               selectedUserIds.length > 0 && 
                                               pushTitle.trim() &&
                                               !isSending) ? '#0065FF' : '#B0BEC5', 
                                cursor: (customMessage.trim() && 
                                        customMessage.trim() !== '<p><br></p>' && 
                                        selectedUserIds.length > 0 &&
                                        !isSending) ? 'pointer' : 'not-allowed'
                            }} 
                            onClick={sendPush}
                        >
                            {isSending ? (
                                <CircularProgress size={24} style={{ color: '#fff' }} />
                            ) : (
                                'Send Push'
                            )}
                        </Button>
                    </Grid2>
                </Grid2>

                <Grid2 item size={8} className="mainBox">
                    <Grid2 style={{display:'flex',alignItems:'center'}}>

                    <Checkbox
                        checked={sendtoall === 1}
                        onChange={(e) => {
                            const isChecked = e.target.checked;
                            setSendtoall(isChecked ? 1 : 0);
                            if (isChecked) {
                                setSelectedUser([...rows]);
                                setSelectedUserIds(rows.map(row => row.user_id || row.driver_id));
                            } else {
                                setSelectedUser([]);
                                setSelectedUserIds([]);
                            }
                        }}
                        inputProps={{ 'aria-label': 'select all users' }}
                    />
                    Select All

                    <Grid2 xs="auto" style={{marginLeft:'2%'}}>
                        <style>
                                {`
                                .PhoneInputCountry {
                                    border-radius: 8px 0px 0px 8px !important;
                                    border: none !important;
                                    background-color: ${customerPhone ? '#F9F9F9' : '#FFFFFF'} !important;
                                    padding: 4px !important;
                                    margin-right: 0px !important;
                                    }
                                    .PhoneInputInput {
                                        font-size: 16px !important;
                                        border: none !important;
                                        outline: none !important;
                                        }
                                        .PhoneInputInput::placeholder {
                                            font-size: 16px !important; /* Increase placeholder text size */
                                            }
                                            `}
                            </style>
                            <PhoneInput
                                defaultCountry={country_code || "IN"}
                                placeholder="Enter phone number"
                                value={customerPhone}
                                onChange={handlePhoneChange}
                                style={{
                                    height: '40px',
                                    width: '90%',
                                    backgroundColor: customerPhone ? '#F9F9F9' : '#FFFFFF',
                                    borderRadius: '8px',
                                    border: '1px solid #E0E0E0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '0 12px'
                                }}
                                />
                        </Grid2>
                        {sendtoall==0 && selectedUser.length>0 && <Grid2 xs="auto" style={{marginLeft:'2%',border:'1px solid #E0E0E0',padding:'10px 20px',borderRadius:'8px'}}>{selectedUser.length} User Selected</Grid2>}
                    </Grid2>
                    
                    <TableContainer className="table-container">
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Select</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>User</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>ID</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                                </TableRow>
                            </TableHead>

                            {driverCustomer==0 && (
                                <TableBody>
                                    {paginatedData?.map((row) => {
                                        return(
                                            <TableRow key={row.user_id}>
                                                <TableCell align="center" sx={{minWidth:'100px'}}>
                                                <Checkbox
                                                        checked={selectedUser.some(selected => selected.user_id === row.user_id)}
                                                        onChange={() => {
                                                            const isSelected = selectedUser.some(selected => selected.user_id === row.user_id);
                                                            if (isSelected) {
                                                                setSelectedUser(selectedUser.filter(selected => selected.user_id !== row.user_id));
                                                                setSelectedUserIds(selectedUserIds.filter(id => id !== row.user_id));
                                                            } else {
                                                                setSelectedUser([...selectedUser, row]);
                                                                setSelectedUserIds([...selectedUserIds, row.user_id]);
                                                            }
                                                            setSendtoall(0); // Reset sendtoall when manually selecting users
                                                        }}
                                                        inputProps={{ 'aria-label': 'select user' }}
                                                    />
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                        <Grid2>
                                                            <Avatar sx={{ borderColor: "#0065FF", border: 1 }}
                                                            alt={row.user_name} src={row.user_image}></Avatar>
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Grid2><Typography>{row.user_name}</Typography></Grid2>

                                                            <Grid2>
                                                                <Typography sx={{ color: "#83888E", fontSize: "12px" }}>
                                                                    {row.phone_number}
                                                                </Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_email}</Typography></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            )}

                            {driverCustomer==1 && (
                                <TableBody>
                                    {paginatedData?.map((row) => {
                                        return(
                                            <TableRow key={row.driver_id}>
                                                <TableCell align="center" sx={{minWidth:'100px'}}>
                                                    <Checkbox
                                                        checked={selectedUser.some(selected => selected.driver_id === row.driver_id)}
                                                        onChange={() => {
                                                            const isSelected = selectedUser.some(selected => selected.driver_id === row.driver_id);
                                                            
                                                            if (isSelected) {
                                                                setSelectedUser(selectedUser.filter(selected => selected.driver_id !== row.driver_id));
                                                                setSelectedUserIds(selectedUserIds.filter(id => id !== row.driver_id));
                                                            } else {
                                                                setSelectedUser([...selectedUser, row]);
                                                                setSelectedUserIds([...selectedUserIds, row.driver_id]);
                                                            }
                                                        }}
                                                        inputProps={{ 'aria-label': 'select user' }}
                                                    />
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                        <Grid2>
                                                            <Avatar sx={{ borderColor: "#0065FF", border: 1 }}
                                                            alt={row.driver_name} src={row.driver_image}></Avatar>
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Grid2><Typography>{row.driver_name}</Typography></Grid2>

                                                            <Grid2>
                                                                <Typography sx={{ color: "#83888E", fontSize: "12px" }}>
                                                                    {row.phone_number}
                                                                </Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.email}</Typography></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            )}
                        </Table>
                        {driverCustomer == 0 && <div className="custom-pagination">
                                            <div className="pagination-info">
                                                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                                    (page + 1) * rowsPerPage,
                                                    paginationInfo.total
                                                )} of ${paginationInfo.total} entries`}
                                            </div>
                                            <div className="pagination-controls">
                                                <button
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    disabled={page === 0}
                                                    className="pagination-arrow"
                                                >
                                                    <img src={prevIcon} alt="Previous" />
                                                </button>
                                                <div className="pagination-numbers">
                                                    {page > 1 && (
                                                        <>
                                                            <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                                                1
                                                            </button>
                                                            <span className="pagination-dots">...</span>
                                                        </>
                                                    )}
                                                    {[...Array(totalPages)]
                                                        .map((_, index) => index)
                                                        .filter((index) => index >= page - 1 && index <= page + 1)
                                                        .map((index) => (
                                                            <button
                                                                key={index}
                                                                onClick={() => handleChangePage(null, index)}
                                                                className={`pagination-number ${page === index ? 'active' : ''}`}
                                                            >
                                                                {index + 1}
                                                            </button>
                                                        ))}
                                                    {page < totalPages - 2 && (
                                                        <>
                                                            <span className="pagination-dots">...</span>
                                                            <button
                                                                onClick={() => handleChangePage(null, totalPages - 1)}
                                                                className="pagination-number"
                                                            >
                                                                {totalPages}
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                                <button
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    disabled={page >= totalPages - 1}
                                                    className="pagination-arrow"
                                                >
                                                    <img src={nextIcon} alt="Next" />
                                                </button>
                                            </div>
                                        </div>}
                    </TableContainer>
                </Grid2>
            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default Pushes;